export default __webpack_public_path__ + "static/fall1-a02cd28e9481b2f7e2a5214878304f98.webp";